/**
 * Table component layout constants.
 * Centralized to ensure consistency across Table, TableHeader, TableRow, and TableCell.
 */

/** Horizontal padding applied to table body and header (left + right) */
export const TABLE_HORIZONTAL_PADDING = 32; // 16px each side

/** Width of the selection checkbox column */
export const SELECTION_COLUMN_WIDTH = 48;

/** Width of the actions column in the table header */
export const ACTIONS_COLUMN_WIDTH_HEADER = 100;

/** Width of the actions column in table rows */
export const ACTIONS_COLUMN_WIDTH_ROW = 140;

/** Height of the table header row */
export const TABLE_HEADER_HEIGHT = 42;

/** Spacing for scrollbar to prevent overlap with content */
export const SCROLLBAR_SPACING = 8;

/** Gap between table rows */
export const TABLE_ROW_GAP = 8;

/** Border radius for table rows */
export const TABLE_ROW_BORDER_RADIUS = 6;

/** Max height for individual table rows */
export const TABLE_ROW_MAX_HEIGHT = 68;

/** Height of the scroll shadow gradient */
export const SCROLL_SHADOW_HEIGHT = 8;

/** Threshold in pixels for detecting scroll position near top/bottom */
export const SCROLL_POSITION_THRESHOLD = 1;
